import * as React from "react";
import { Block, BlockProps } from "baseui/block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type SidePadderProps = {
  padding?: "page" | "section" | "inner-section" | "flow" | "none";
  children: React.ReactNode;
} & BlockProps;
export const SidePadder: React.FC<SidePadderProps> = (props) => {
  const [, theme] = useStyletron();
  const { children, padding = "section", ...restProps } = props;
  const paddings = {
    page: [
      theme.sizing.scale1600,
      theme.sizing.scale600,
      theme.sizing.scale1600,
      theme.sizing.scale1600,
    ],
    section: [theme.sizing.scale900],
    none: 0,
    flow: [0, 0, 0, theme.sizing.scale4800],
  };
  return (
    <Block
      paddingLeft={paddings[padding]}
      paddingRight={paddings[padding]}
      {...restProps}
    >
      {children}
    </Block>
  );
};
